import { render, staticRenderFns } from "./CustomerSearchItem.vue?vue&type=template&id=1a042f9a&"
import script from "./CustomerSearchItem.vue?vue&type=script&lang=js&"
export * from "./CustomerSearchItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports